import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/operations'),
    name: 'operations_dashboard',
    component: () => import('./Index.vue'),
    meta: { permissions: ['administrator', 'operations_dashboard_view'] },
  },
  {
    path: frontendURL('accounts/:accountId/follow-ups'),
    name: 'follow_ups_index',
    component: () => import('./FollowUps.vue'),
    meta: {
      permissions: [
        'administrator',
        'agent',
        'conversation_manage',
        'conversation_unassigned_manage',
        'conversation_participating_manage',
      ],
    },
  },
];
